
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/fansi-class",
      function () {
        return require("private-next-pages/help/fansi-class.tsx");
      }
    ]);
  